var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCard56(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_425_6309",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 7,
    width: 33,
    height: 42
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3067 7.2252L14.3972 18.9941C12.941 19.631 12 21.0696 12 22.659V46.9424C12 48.3846 13.4801 49.3527 14.8014 48.7748L41.7109 37.0059C43.1671 36.369 44.1081 34.9304 44.1081 33.341V9.05762C44.1081 7.61542 42.628 6.64731 41.3067 7.2252Z",
    fill: "#8DCCFC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_425_6309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3067 7.2252L14.3972 18.9941C12.941 19.631 12 21.0696 12 22.659V46.9424C12 48.3846 13.4801 49.3527 14.8014 48.7748L41.7109 37.0059C43.1671 36.369 44.1081 34.9304 44.1081 33.341V9.05762C44.1081 7.61542 42.628 6.64731 41.3067 7.2252Z",
    fill: "#75C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1081 28.5946L12 42.6372V47.6216L44.1081 33.5791V28.5946Z",
    fill: "#1D1D1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.432 20.5827L36.3776 22.3847C36.0164 22.5452 35.7837 22.9033 35.7837 23.2985V26.8637C35.7837 27.2256 36.1561 27.4676 36.4868 27.3206L40.5412 25.5187C40.9023 25.3581 41.135 25 41.135 24.6048V21.0396C41.135 20.6778 40.7626 20.4358 40.432 20.5827Z",
    fill: "#FFCB7C"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard56);
export default __webpack_public_path__ + "static/media/card_56.48662938.svg";
export { ForwardRef as ReactComponent };